import React, { Component } from "react";
import { shareFacebook, shareWhatsapp, openNegishut, shareTwitter } from "../Services/Sharing"
import "./Header.scss"

export default class Header extends Component {
  constructor() {
    super()
    this.state = {}
  }
  render() {
    return (
      <header>
        <div id="header">
          <div className="padding">
            <div className="container">
              <div className="publisher">
                <a href="https://ynet.co.il/" target="_blank">
                <div className="ynet"></div>
                </a>
                <div className="line"></div>
                <div className="mainlogo" onClick={() => window.open("https://www.osem.co.il/",'_blank')}></div>
              </div>
              <div className="utils">
                <div className={`share`}>
                  {/* <div onClick={shareTwitter} className="twitter"></div> */}
                  <div onClick={shareWhatsapp} className="whatsapp"></div>
                  <div onClick={shareFacebook} className="facebook"></div>
                  <div onClick={openNegishut} className="negishut"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="virtualHeader"></div>
      </header>
    );
  }
}


// WEBPACK FOOTER //
// ./src/Components/Header/Header.jsx